import { useState, useCallback } from 'react';

interface ModalController {
	isModalOpen: boolean,
	openModal: () => void,
	closeModal: () => void,
}

const useModal = (): ModalController => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const openModal = useCallback(() => {
		setIsModalOpen(true);
	}, [setIsModalOpen]);

	const closeModal = useCallback(() => {
		setIsModalOpen(false);
	}, [setIsModalOpen]);

	return {
		isModalOpen,
		closeModal,
		openModal,
	};
};

export {useModal};